import { Box } from "@mui/material"
import { useMemo } from "react"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import { useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store"
import { TipoPropostaInput } from "../tipoProposta"
import { JustificativaValorServico } from "src/components/projetos/containers/InputsSection/containers/InputJustificativaValorServico"
import { ValorServicoInput } from "../valorServico"

export const TipoPropostaMobile = () => {
  const { justificativa_valor_servico, valor_minimo_servico, valor_servico, tipo_proposta, recebe_servico, resultado_calculos, valor_servico_pis_cofins } = useProjetosOffGridStore(store => store.state.data);
  const { changeValue: changeStoreValue, syncFileiras, addSolucaoCalculada } = useProjetosOffGridStore(store => store.actions)
  const permissoes = PermissionUtil.getPermissions();
  const servicoObrigatorio = useMemo(()=>{
      return tipo_proposta?.value === 'gerador-com-instalacao'
    },[tipo_proposta?.value]);

  const mostrarCampoValorServico = useMemo(()=>{
    return !!(servicoObrigatorio && recebe_servico) 
  },[servicoObrigatorio, recebe_servico]);

  const exibirJustificativaValorServico = useMemo(() => {
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_EDITAR_ESPECIAL_SERVICO, permissoes)) return false;
    if (!mostrarCampoValorServico) return false;
    
    if (!valor_servico) return false;
    if (!valor_minimo_servico) return false;

    const valorServicoProjeto = Number(valor_servico || 0)
    return valorServicoProjeto < Number(valor_minimo_servico || 0);
  },[mostrarCampoValorServico, permissoes, valor_minimo_servico, valor_servico])
  
  return (
    <Box style={{padding: '8px 16px 8px 16px'}}>
        <TipoPropostaInput />
        <ValorServicoInput servicoObrigatorio={servicoObrigatorio} />
        {exibirJustificativaValorServico && (
            <Box>
                <JustificativaValorServico
                formState={{ justificativa_valor_servico: justificativa_valor_servico || "" } as any }
                setFormState={(data) => changeStoreValue({ justificativa_valor_servico: data.justificativa_valor_servico })} />
            </Box>
        )}
    </Box>
  )
}
